import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Spacer, Surface as DesignSystemSurface, Typography, Colors, } from '@zapier/design-system';
import Section from '@zapier/product-get-help/esm/components/shared/Section';
const contentCss = (size) => css `
    padding: ${size === 'small' ? '20px 10px' : '30px 40px'};
    ${Typography.paragraph3}
    color: ${Colors.neutral400};
`;
/**
 * The Design System `<Surface>` component, configured as we use it in Get Help.
 */
const Surface = ({ children, hasShadow = false, size = 'large', title, backgroundColor, titleTypography, }) => {
    return (isolateComponent(DesignSystemSurface, { backgroundColor: backgroundColor ? backgroundColor : 'transparent', borderColor: 'neutral400', shadow: hasShadow ? 'elevation5' : undefined },
        isolateComponent("div", { css: contentCss(size) }, title ? (isolateComponent(Section, { size: size, title: title, titleTypography: titleTypography },
            isolateComponent(Spacer, { height: 10 }),
            children)) : (children))));
};
export default Surface;
